import { UIKitIcon } from '../icon';

export const treeIcon: UIKitIcon = {
  name: 'tree',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><line x1="20" y1="26" x2="12" y2="26" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-miterlimit="10"/><path d="M19,6a7,7,0,0,0-5.17,2.29A5.8,5.8,0,0,0,12,8a6,6,0,0,0,0,12h7A7,7,0,0,'
  + '0,19,6Z" fill="none" stroke="inherit" stroke-miterlimit="10"/><line x1="16" y1="26" x2="16" y2="13" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-miterlimit="10"/><line x1="14" y1="16" x2="16" y2="18" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-miterlimit="10"/><line x1="16" y1="15" x2="18" y2="13" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-miterlimit="10"/></svg>',
};
